import { brown } from '@mui/material/colors';

export const XS_CARD_WIDTH = '320px';
export const MD_CARD_WIDTH = '800px';
export const LG_CARD_WIDTH = '1200px';

export const secondaryColor = brown[500];

export const defaultIconSize = 30;
